import styled from 'styled-components'
import { vw } from '../../untils/styled'
import rateWrapper from '../../assets/img/rateWrapper.png'
import numberbg from '../../assets/img/numberbg.png'

export const Body = styled.div`
    padding: 0 ${vw(30)};
`
export const SectionWrapper = styled.div`
    width: ${vw(690)};
    height: ${vw(180)};
    background: url(${rateWrapper}) no-repeat;
    background-color: ${props => props.fixed ? '#000' : 'transparent'};
    background-size: 100% auto;
    background-position: center bottom;
    position: relative;
    position: sticky;
    top: 0;
    z-index: 97;

    .icon {
        position: absolute;
        top: 54%;
        left: ${vw(210)};
        transform: translateY(-50%);
        width: ${vw(26)};
        height: ${vw(26)};
    }
`

export const NumberWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: ${vw(440)};
    height: ${vw(100)};
    position: absolute;
    right: ${vw(23)};
    top: 50%;
    transform: translateY(-45%);
`

export const Stage = styled.div`
    width: ${props => vw(props.width)};
    height: ${vw(125)};
    line-height: ${props => vw(props.width * 5 / 4)};
    overflow: hidden;
    perspective: 300px;
    position: relative;
    background: url(${numberbg}) no-repeat;
    background-size: 100% auto;
    opacity: 0.87;
    margin-right: 3px;

    .symbol {
        color: #f8f8f8;
        font-size: ${vw(100)};
        padding-left: ${vw(15)};
    }
`

export const Wrapper = styled.div`
    position: absolute;
    left: ${vw(20)};
    transform-style: preserve-3d;
    backface-visibility: hidden;
    height: 100%;
    transform: ${props => `rotateX(${props.x}deg)`};
    transition: opacity 1s, transform 1s;
`

export const NumberStyle = styled.div`
    font-family: DIGIFAW;
    position: absolute;
    display: flex;
    backface-visibility: hidden;
    text-align: center;
    color: #f8f8f8;
    font-size: ${props => vw(props.fontSize)};
    height: 100%;
    align-items: center;
    transform: ${props => `rotateX(${props.x}deg) translateZ(${vw(140)})`};
`

export const DynamicSliderWrap =styled.div`
	background-image: linear-gradient(152deg, 
		#434756 0%, 
		#363a45 100%), linear-gradient(
		#3c404f, 
        #3c404f);
    
    > div:first-of-type {
        background: ${props => `
                            radial-gradient(circle at bottom left, #23252e ${vw(10)}, transparent 0) bottom left,
                            radial-gradient(circle at bottom right, #23252e ${vw(10)}, transparent 0) bottom right`};
    }
    > div:last-of-type {
        background: ${props => `
                            radial-gradient(circle at top left, #23252e ${vw(10)}, transparent 0) top left,
                            radial-gradient(circle at top right, #23252e ${vw(10)}, transparent 0) top right`};
    }
`

export const SliderWrapper = styled.div`
    height: ${vw(246)};
    border-bottom: 1px dashed #2f333f;
    padding: 0 ${vw(30)};
    background: ${props => `radial-gradient(circle at top left, #23252e ${vw(10)}, transparent 0) top left,
                            radial-gradient(circle at top right, #23252e ${vw(10)}, transparent 0) top right,
                            radial-gradient(circle at bottom left, #23252e ${vw(10)}, transparent 0) bottom left,
                            radial-gradient(circle at bottom right, #23252e ${vw(10)}, transparent 0) bottom right`};
`

export const SliderLabel = styled.div`
    display: flex;
    height: ${vw(155)};
    align-items: center;
    justify-content: space-between;

    > div:nth-of-type(1) {
        display: flex;
        align-items: center;

        img {
            width: ${vw(84)};
            height: ${vw(84)};
            margin-right: ${vw(20)};
        }

        span {
            font-size: ${vw(30)};
            color: #fefefe;
            opacity: 0.8;
        }        
    }

    > div:nth-of-type(2) {
        width: ${vw(90)};
        height: ${vw(40)};
        text-align: center;
        line-height: ${vw(40)};
        border-radius: ${vw(20)};
        border: solid 1px #dfbf82;
        font-size: ${vw(28)};
        color: #dfbf82;
        opacity: 0.8;
    }
`
